import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

const db = getFirestore();

const storageInstance = getStorage()
const storage = ref(storageInstance, "tutorialsVideos/");
const storageImages = ref(storageInstance, "tutorialsImages/");

export default {
    state: {
        tutorialsList: [],
        loadingStatusTutorialVideo: 0,
        loadingStatusTutorialImage: 0,
        categoriesTutorialsList: []
    },
    mutations: {
        SET_TUTORIALS_LIST(state, tutorialsList) {
            state.tutorialsList = tutorialsList
        },
        SET_VALUE_LOADING_STATUS_TUTORIAL_VIDEO(state, progress) {
            state.loadingStatusTutorialVideo = progress
        },
        SET_VALUE_LOADING_STATUS_TUTORIAL_IMAGE(state, progress) {
            state.loadingStatusTutorialImage = progress
        },
        DELETE_TUTORIAL_FROM_ARRAY(state, tutorial) {
            const index = state.tutorialsList.indexOf(tutorial);
            if (index > -1) {
                state.tutorialsList.splice(index, 1);
            }
        },
        SET_CATEGORIES_TUTORIALS_LIST(state, categoriesTutorialsList){
            state.categoriesTutorialsList = categoriesTutorialsList
        },
    },
    actions: {
        GetTutorialsList({ commit }) {
            return new Promise((resolve, reject) => {
                getDocs(collection(db, "tutorialsList"))
                    .then(async(querySnapshot) => {
                        var tutorialsList = [];
                        querySnapshot.forEach(async(doc) => {
                            let tutorial = doc.data();
                            tutorial.id = doc.id;
                            let category = await getDoc(tutorial.category);
                            tutorial.category = category.data()
                            const splittedUrl = tutorial.videoLink.split('/');
                            let utilPart = splittedUrl[splittedUrl.length-1];
                            if (utilPart.includes('watch?v=')) {
                                utilPart = utilPart.replace('watch?v=','');
                            }
                            if (utilPart.includes('&t=')) {
                                const sp = utilPart.split('&t=');
                                utilPart = sp[0];
                            }
                            tutorial.previewVideo = `https://www.youtube.com/embed/${utilPart}`;
                            
                            tutorialsList.push(tutorial);
                        });
                        // console.log('TUTORIALS: ',tutorialsList);
                        
                        commit("SET_TUTORIALS_LIST", tutorialsList);
                        resolve(tutorialsList);
                    }).catch((err) => {
                        reject(err)
                    })
            });
        },
        GetTutorial({ }, tutorial){
            return new Promise(async (resolve, reject) => {
                try {
                    let resTutorial = await getDoc(doc(db, "tutorialsList", tutorial.id))
                    let gettedTutorial = resTutorial.data()
                    let category = await getDoc(gettedTutorial.category);
                    gettedTutorial.category = category.data()
                    resolve(gettedTutorial)
                } catch(error) {
                    reject(error)
                }
            })
        },
        DeleteTutorial({}, tutorial) {
            return new Promise(async(resolve, reject) => {
                await deleteDoc(doc(db, "tutorialsList", tutorial.id))
                    .then((res) => {
                        resolve(tutorial.id);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        UploadVideoTutorial({ commit }, tutorial) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `tutorialsVideos/${random}`);
                    let bytes = new Blob([new Uint8Array(tutorial.video.blob)]);
                    console.log('storageRef', storageRef.name);
                    let metadata = {
                        contentType: 'video/mp4'
                    }
                    
                    // Upload the bytes
                    await uploadBytes(storageRef, bytes, metadata);
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        UploadImageTutorial({ commit }, tutorial) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `tutorialsImages/${random}`);
                    console.log('storageRef', storageRef.name);
                    
                    // Upload the string
                    await uploadString(storageRef, tutorial.image.img, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        CreateTutorial({}, tutorial) {
            return new Promise(async(resolve, reject) => {
                delete tutorial.image.img
                                 tutorial.category = doc(db, "categoriesTutorialsList", tutorial.category.id);
                 const newDocRef = doc(collection(db, "tutorialsList"));
                 tutorial.id = newDocRef.id;
                 tutorial.createdAt = new Date()
                 tutorial.updatedAt = new Date()
                 await setDoc(newDocRef, tutorial)
                    .then(async(res) => {
                        resolve(newDocRef.id);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            })
        },
        UpdateTutorial({}, tutorial) {
            return new Promise(async(resolve, reject) => {
                if(tutorial.createdAt) {
                    delete tutorial.createdAt
                }
                tutorial.updatedAt = new Date()
                if (tutorial.image.img) {
                    delete tutorial.image.img
                }
                                 tutorial.category = doc(db, "categoriesTutorialsList", tutorial.category.id);
                await updateDoc(doc(db, "tutorialsList", tutorial.id), tutorial)
                    .then((res) => {
                        resolve(tutorial.id);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        GetCategoriesTutorialsList({ commit }){
            return new Promise(async (resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "categoriesTutorialsList"))
                    const categoriesTutorialsList = []
                    querySnapshot.forEach((doc) =>  {
                        categoriesTutorialsList.push(doc.data())
                    })
                    commit('SET_CATEGORIES_TUTORIALS_LIST', categoriesTutorialsList)
                    resolve(categoriesTutorialsList)
                } catch(error) {
                    reject(error)
                }
            })
        },
        CreateCategoryTutorial({}, categoryTutorial) {
            return new Promise(async(resolve, reject) => {
                try {
                                         const newDocRef = doc(collection(db, "categoriesTutorialsList"));
                     categoryTutorial.id = newDocRef.id;
                     await setDoc(newDocRef, categoryTutorial);
                     resolve(newDocRef.id);
                } catch (error) {
                    reject(error);
                }
            })
        },
        UpdateCategoryTutorial({}, category) {
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(collection(db, "categoriesTutorialsList"), category.id), category)
                    resolve(category.id);
                } catch (error) {
                    reject(error);
                }
            });
        },
        DeleteCategoryTutorial({}, category) {
            return new Promise(async(resolve, reject) => {
                try {
                                         await deleteDoc(doc(db, "categoriesTutorialsList", category.id))
                    resolve(category.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
    },
    getters: {
        getTutorials(state) {
            return state.tutorialsList
        },
        getLoadingStatusTutorialVideo(state) {
            return state.loadingStatusTutorialVideo
        },
        getLoadingStatusTutorialImage(state) {
            return state.loadingStatusTutorialImage
        },
        getCategoriesTutorialsList(state) {
            return state.categoriesTutorialsList
        },
    }
}